import { LibraryRoutesConfig } from './library-routes.config';

export class LibraryRoutes {
	public static readonly LIBRARY = LibraryRoutesConfig.LIBRARY_BASE_URL;
	public static SCORM_TINCAN_HOME_ROUTE = `${LibraryRoutesConfig.LIBRARY_BASE_URL}/${LibraryRoutesConfig.SCORM_TINCAN_SEGMENT}`;
}
